
























import type { AxWindow } from '@aspenware-library/types'
import { defineComponent } from '@vue/composition-api'
import { useUiState } from '@aspenware-library/composables'
import HeaderNavigation from './HeaderNavigation.vue'
import CartIcon from './CartIcon.vue'
const { toggleNavSidebar } = useUiState()

export default defineComponent({
  name: 'AppHeader',
  components: {
    HeaderNavigation,
    CartIcon,
  },
  props: {
    contentClass: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      brandSite: undefined as string | undefined,
    }
  },
  mounted() {
    const win = window as AxWindow
    this.brandSite = win?.storeSettings?.Store.BrandUrl
    win.dispatchEvent(new CustomEvent('ros-header-mounted'))
  },
  methods: {
    toggleNavSidebar,
  },
})
